"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _SwipeableDrawer = _interopRequireDefault(require("@material-ui/core/SwipeableDrawer"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _Menu = require("material-ui-shell/lib/providers/Menu");

var _Theme = require("material-ui-shell/lib/providers/Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var drawerWidth = 240;
var iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _drawerPaper, _drawerPaperClose;

  return {
    toolbar: _extends({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 8px'
    }, theme.mixins.toolbar),
    drawerPaper: (_drawerPaper = {
      height: '100vh',
      width: drawerWidth
    }, _drawerPaper[theme.breakpoints.up('md')] = {
      position: 'relative'
    }, _drawerPaper.transition = theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }), _drawerPaper),
    drawerPaperOpen: {
      height: '100vh',
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    drawerPaperClose: (_drawerPaperClose = {
      height: '100vh',
      overflowX: 'hidden',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      width: theme.spacing(1) * 7
    }, _drawerPaperClose[theme.breakpoints.up('sm')] = {
      width: theme.spacing(1) * 9
    }, _drawerPaperClose),
    hide: {
      display: 'none'
    }
  };
});

var ResponsiveMenu = function ResponsiveMenu(_ref) {
  var children = _ref.children,
      width = _ref.width;
  var classes = useStyles();

  var _useAppTheme = (0, _Theme.useTheme)(),
      isRTL = _useAppTheme.isRTL;

  var menuContext = (0, _Menu.useMenu)();

  var _ref2 = menuContext || {},
      toggleThis = _ref2.toggleThis,
      isDesktop = _ref2.isDesktop,
      isMiniMode = _ref2.isMiniMode,
      isMenuOpen = _ref2.isMenuOpen,
      isMobileMenuOpen = _ref2.isMobileMenuOpen;

  var handleDrawerToggle = function handleDrawerToggle() {
    toggleThis('isMobileMenuOpen');
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      boxSizing: 'content-box'
    }
  }, /*#__PURE__*/_react.default.createElement(_SwipeableDrawer.default, {
    disableBackdropTransition: !iOS,
    disableDiscovery: iOS,
    variant: isDesktop ? 'permanent' : 'temporary',
    onClose: handleDrawerToggle,
    anchor: !isDesktop ? undefined : isRTL ? 'right' : 'left',
    classes: {
      paper: isDesktop ? (0, _clsx.default)(classes.drawerPaperOpen, !isMenuOpen && classes.drawerPaperClose, !isMiniMode && !isMenuOpen && classes.hide) : classes.drawerPaper
    },
    open: isDesktop ? !!isMenuOpen : !!isMobileMenuOpen,
    onOpen: handleDrawerToggle,
    ModalProps: {
      keepMounted: true // Better open performance on mobile.

    }
  }, children));
};

ResponsiveMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.any
} : {};
var _default = ResponsiveMenu;
exports.default = _default;
module.exports = exports.default;